import { Injectable/*, Injector*/ } from '@angular/core';
import { MeetingSettings } from '../models/MeetingSettings';
import { MediaDevice } from '../models/MediaDevice';
import { environment } from 'src/environments/environment';

declare const $:any;

@Injectable({
  providedIn: 'root'
})

export class UtilService {
  readonly vcirclecookiekeyname = environment.vcirclecookiekeyname;

  meetingmode: string = "meetingmode";
  focusmode: string = "focusmode";
  defaultphotourl: string = '/assets/user2.png';
  audioDevices: MediaDevice[] = [];
  videoDevices: MediaDevice[] = [];
  deviceInfos: MediaDeviceInfo[] = [];
  private audioAccessiblePromise: Promise<boolean>;
  private videoAccessiblePromise: Promise<boolean>;
  defaultCamera;
  defaultMicrophone;
  //static injector: Injector;
  constructor(private settings: MeetingSettings) { 
  }

  isVisible(elem, scrollElement, completelyVisible: boolean){
      // var $elem = $(elem);
      // var $window = $(scrollElement);
      // var docViewTop = $window.scrollTop();
      // var docViewBottom = docViewTop + $window.height();
      // var elemTop = $elem.offset().top;//elem.offsetTop;
      // var elemBottom = elemTop + $elem.height();
      
      // return (((elemBottom+offset) >= docViewBottom) && ((elemTop-offset) <= docViewTop)) || (((elemBottom-offset) <= docViewBottom) && ((elemTop+offset) >= docViewTop));

      //let lowestVisible = scrollElement.offsetHeight + scrollElement.clientHeight;
      let boundingRect: DOMRect = elem.getBoundingClientRect();

      const viewportVisibleBottom = scrollElement.scrollTop + scrollElement.clientHeight;
      const viewportVisibleTop = scrollElement.scrollTop;

      const topVisible = boundingRect.top <= viewportVisibleBottom && boundingRect.top >= viewportVisibleTop;
      const bottomVisible = boundingRect.bottom <= viewportVisibleBottom && boundingRect.bottom >= viewportVisibleTop;

      if(completelyVisible){
        return topVisible && bottomVisible;
      }
      else{
        return topVisible || bottomVisible;
      }
  }

  async enterFullscreen(){
    var element: any = document.querySelector('body');
    var requestFullScreenMethod = element.requestFullScreen || element.webkitRequestFullScreen || element.mozRequestFullScreen || element.msRequestFullScreen;
    if(requestFullScreenMethod){
      try{
        const fullscreenpromise: Promise<any> = requestFullScreenMethod.call(element);
        await fullscreenpromise;
        this.settings.inFullScreen = true;
      }
      catch(error){
        this.settings.inFullScreen = false;
        console.error(error);
      }

      
    }
  }

  async enterLandscape(){
    try{
      await screen.orientation['lock']('landscape');
    }
    catch(error){
      console.error(error);
    }
  }

  exitLandscape(){
    screen.orientation.unlock();
  }

  exitFullscreen(){
    var element: any = document;
    var exitFullScreenMethod = element.cancelFullScreen || element.webkitCancelFullScreen || element.mozCancelFullScreen || element.msCancelFullScreen;
    if(exitFullScreenMethod){
      exitFullScreenMethod.call(element);
      screen.orientation.unlock();
      this.settings.inFullScreen = false;
    }
    // await screen.orientation.lock("landscape").catch(error => console.log(error));
    // this.settings.inFullScreen = true;
  }

  mobile() {
    let check = false;
    const _window: any = window;
    (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||_window.opera);
    return check;
  }

  // mergeAudioStreams(stream1: MediaStream, stream2: MediaStream) {
  //   const context = new AudioContext();
  //   const destination = context.createMediaStreamDestination();
  //   //let hasDesktop = false;
  //   //let hasVoice = false;
    
  //       const source1 = context.createMediaStreamSource(stream1);
  //       //const desktopGain = context.createGain();
  //       //desktopGain.gain.value = 1;
  //       source1.connect(destination);
    
  //       const source2 = context.createMediaStreamSource(stream2);
  //       //const voiceGain = context.createGain();
  //       //voiceGain.gain.value = 1;
  //       source2.connect(destination);
    

  //   return destination.stream;
  // }

  sleep(milliseconds){
    return new Promise((resolve, reject) =>{
      setTimeout(resolve, milliseconds);
    });
  }

  testAudioAccessible(){
    if(!this.audioAccessiblePromise){
      this.audioAccessiblePromise = new Promise<boolean>(async (resolve, reject) => {
        let audioStream;
        try{
          audioStream = await navigator.mediaDevices.getUserMedia({audio: true, video: false});
          
          resolve(true);
        }
        catch(error){
          console.error(error);
          resolve(false);
        }
        finally{
          if(audioStream){
            audioStream.getAudioTracks().forEach((track) => {
              track.stop();
            });
          }
        }
      });
    }
    return this.audioAccessiblePromise;
  }

  async testVideoAccessible(){
    if(!this.videoAccessiblePromise){
      this.videoAccessiblePromise = new Promise<boolean>(async (resolve, reject) => {
        let videoStream;
        try{
          videoStream = await navigator.mediaDevices.getUserMedia({audio: false, video: true});

          resolve(true);
        }
        catch(error){
          console.error(error);
          resolve(false);
        }
        finally{
          if(videoStream){
            videoStream.getVideoTracks().forEach((track) => {
              track.stop();
            });
          }
        }
      });
    };
    return this.videoAccessiblePromise;
  }

  async setDevicesList(){
    this.deviceInfos = await navigator.mediaDevices.enumerateDevices();
    console.log(this.deviceInfos);
    this.videoDevices.splice(0);
    this.audioDevices.splice(0);
    for (var i = 0; i < this.deviceInfos.length; i++) {
      var deviceInfo = this.deviceInfos[i];
      const device = new MediaDevice();
      device.DeviceId = deviceInfo.deviceId;
      if (deviceInfo.kind === 'audioinput') {
          device.DeviceName = deviceInfo.label || 'microphone ' + (this.audioDevices.length + 1);
          device.Type = 'audio';
          this.audioDevices.push(device);
      } else if (deviceInfo.kind === 'videoinput') {
          device.DeviceName = deviceInfo.label || 'webcam ' + (this.videoDevices.length + 1);
          device.Type = 'video';
          this.videoDevices.push(device);
      } else {
          //console.log('Some other kind of source/device: ', deviceInfo);
      }
    }

    if(!this.settings.selectedCamera){
      this.selectDefaultVideoDevice();
    }

    if(!this.settings.selectedMicrophone){
      this.selectDefaultAudioDevice(); 
    }
  }

  selectDefaultVideoDevice(){
    if(this.videoDevices.length > 0){
      const communicationsDevices = this.videoDevices.filter((device) => {
        return device.DeviceId == "communications"
      });
      const defaultDevices = this.videoDevices.filter((device) => {
        return device.DeviceId == "default";
      });

      if(communicationsDevices.length > 0){
        this.settings.selectedCamera = communicationsDevices[0].DeviceId;
      }
      else if(defaultDevices.length > 0){
        this.settings.selectedCamera = defaultDevices[0].DeviceId;
      }
      else{
        this.settings.selectedCamera = this.videoDevices[0].DeviceId;
      }
      this.defaultCamera = this.settings.selectedCamera;
    }
    console.log('finished setting default video device');
  }

  selectDefaultAudioDevice(){
    if(this.audioDevices.length > 0){
      const communicationsDevices = this.audioDevices.filter((device) => {
        return device.DeviceId == "communications"
      });
      const defaultDevices = this.audioDevices.filter((device) => {
        return device.DeviceId == "default";
      });
      const bluetoothDevices = this.audioDevices.filter((device) => {
        return device.DeviceName.toLowerCase().includes('bluetooth');
      });
      const speakerphoneDevices = this.audioDevices.filter((device) => {
        return device.DeviceName.toLowerCase().includes('speaker');
      });

      if(communicationsDevices.length > 0){
        this.settings.selectedMicrophone = communicationsDevices[0].DeviceId;
      }
      else if(bluetoothDevices.length > 0){
        this.settings.selectedMicrophone = bluetoothDevices[0].DeviceId;
      }
      else if(speakerphoneDevices.length > 0){
        this.settings.selectedMicrophone = speakerphoneDevices[0].DeviceId;
      }
      else if(defaultDevices.length > 0){
        this.settings.selectedMicrophone = defaultDevices[0].DeviceId;
      }
      else{
        this.settings.selectedMicrophone = this.audioDevices[0].DeviceId;
      }
    }
    this.defaultMicrophone = this.settings.selectedMicrophone;

    console.log('finished setting default audio device');
    //this.settings.mediaDevicesSet = true;
  }

  linkify(inputText) {
    var replacedText, replacePattern1, replacePattern2, replacePattern3;

    //URLs starting with http://, https://, or ftp://
    replacePattern1 = /(\b(https?|ftp):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gim;
    replacedText = inputText.replace(replacePattern1, '<a href="$1" target="_blank">$1</a>');

    //URLs starting with "www." (without // before it, or it'd re-link the ones done above).
    replacePattern2 = /(^|[^\/])(www\.[\S]+(\b|$))/gim;
    replacedText = replacedText.replace(replacePattern2, '$1<a href="http://$2" target="_blank">$2</a>');

    //Change email addresses to mailto:: links.
    replacePattern3 = /(([a-zA-Z0-9\-\_\.])+@[a-zA-Z\_]+?(\.[a-zA-Z]{2,6})+)/gim;
    replacedText = replacedText.replace(replacePattern3, '<a href="mailto:$1">$1</a>');

    return replacedText;
  }

  getVCircleUsername() {
    var nameEQ = this.vcirclecookiekeyname + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
  }
  setVCircleUsername(username: string) {
    document.cookie = this.vcirclecookiekeyname + "=" + username;
  }
  
  writeCookie(name: string, value: string) {
    document.cookie = `${name}=${value}; path=/`;
    if (!document.cookie.includes(name + '=')) {
      document.cookie = `${name}=${value}; path=/; SameSite=None; Secure; Partitioned`;
    }
  }
}
